var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import AccessControlPermissionItems from '@project/containers/AccessControlPermissionItems/Loadable';
import AccessControlAPIKeys from '@project/containers/AccessControlAPIKeys/Loadable';
import AccessControlRoles from '@project/containers/AccessControlRoles/Loadable';
import AccessControlTargetPermissions from '@project/containers/AccessControlTargetPermissions/Loadable';
import AccessControlRolePermissions from '@project/containers/AccessControlRolePermissions/Loadable';
import Translations from '@project/containers/Translations/Loadable';
import Translation from '@project/containers/Translation/Loadable';
import Languages from '@project/containers/Languages/Loadable';
import State from '@project/containers/State/Loadable';
import Storage from '@project/containers/Storage/Loadable';
import Variable from '@project/containers/Variable/Loadable';
import Environment from '@project/containers/Environment/Loadable';
import StylesListPage from '@project/containers/StylesListPage/Loadable';
import StylesPage from '@project/containers/StylesPage/Loadable';
import StyleNew from '@project/containers/StyleNew/Loadable';
import LogicBuilderPage from '@project/containers/LogicBuilderPage/Lodable';
import ViewNew from '@project/containers/ViewNew/Loadable';
import LegacyViewBuilder from '@project/containers/ViewBuilder/LegacyViewBuilder/Loadable';
import Dataset from '@project/containers/DatasetDetails/Loadable';
import DatasetRow from '@project/containers/DatasetRow/Loadable';
import PushNotificationDetailsPage from '@project/containers/PushNotificationDetailsPage/Loadable';
import ItemCopy from '@project/containers/ItemCopy/Loadable';
import DatasetsList from '@project/containers/DatasetsList/Loadable';
import DatasetNew from '@project/containers/DatasetNew/Loadable';
import DatasetEdit from '@project/containers/DatasetEdit/Loadable';
import MediaExplorer from '@project/containers/MediaExplorer/Loadable';
import Versions from '@project/containers/Versions/Loadable';
import VersionNew from '@project/containers/VersionNew/Loadable';
import PlatformsPage from '@project/containers/Publishing/Loadable';
import PlatformsWebPage from '@project/containers/Publishing/Web/Loadable';
import PlatformsPlayStorePage from '@project/containers/Publishing/PlayStore/Loadable';
import PlatformsAppStorePage from '@project/containers/Publishing/AppStore/Loadable';
import PlatformsBuildsPage from '@project/containers/Publishing/Distribution/Loadable';
import PublicationsPage from '@project/containers/PublicationsPage/Loadable';
import PublicationsUpsertPage from '@project/containers/PublicationsUpsertPage/Loadable';
import Groups from '@project/containers/Groups/Loadable';
import GroupNew from '@project/containers/GroupNew/Loadable';
import AdminNew from '@project/containers/AdminNew/Loadable';
import Permissions from '@project/containers/Permission/Loadable';
import DataSetPermissions from '@project/containers/DatasetRulesPage/Loadable';
import TargetPermissions from '@project/containers/TargetPermissions/Loadable';
import AppAdminPermissions from '@project/containers/AppAdminPermissions/Loadable';
import GroupDetails from '@project/containers/GroupDetails/Loadable';
import AppAdminDetails from '@project/containers/AppAdminDetails/Loadable';
import AppUsers from '@project/containers/AppUsers/Loadable';
import UserGroups from '@project/containers/UserGroups/Loadable';
import AppUserEdit from '@project/containers/AppUserEdit/Loadable';
import UserInvite from '@project/containers/UserInvite/Loadable';
import AppOverview from '@project/containers/AppOverview/Loadable';
import AppSettings from '@project/containers/AppSettings/Loadable';
import IntegrationsPage from '@project/containers/Integrations/IntegrationsPage/Loadable';
import IntegrationNew from '@project/containers/Integrations/IntegrationNew/Loadable';
import Integration from '@project/containers/Integrations/IntegrationPage/Loadable';
import IntegrationMethodCreatePage from '@project/containers/Integrations/IntegrationMethodCreatePage/Loadable';
import Admins from '@project/containers/Admins/Loadable';
import CreateAdminRole from '@project/containers/CreateAdminRole/Loadable';
import AppAdmins from '@project/containers/AppAdmins/Loadable';
import InviteAppAdmin from '@project/containers/InviteAppAdmin/Loadable';
import ViewsPage from '@project/containers/ViewsPage/Loadable';
import OldPushNotifications from '@project/containers/PushNotifications/OldPushNotifications';
import PushNotifications from '@project/containers/PushNotifications/Loadable';
import PushNotificationTemplates from '@project/containers/PushNotificationTemplates/Loadable';
import PushNotificationTemplatesEdit from '@project/containers/PushNotificationTemplatesEdit/Loadable';
import MakeTemplateBasicPage from '@project/containers/MakeTemplateBasicPage/Loadable';
import SelectPreview from '@project/containers/SelectPreview/Loadable';
import personalizationPage from '@project/containers/PersonalizationPage/Loadable';
import TemplatePublishPage from '@project/containers/TemplatePublishPage/Loadable';
import PatchSelectRedirectPage from '@project/containers/PatchSelectRedirectPage/Loadable';
import PushNotificationsSenderApps from '@project/containers/PushNotificationsSenderApps';
import UsersSharedApps from '@project/containers/UsersSharedApps';
import StructureBuilderPage from '@project/containers/StructureBuilderPage/Loadable';
export var routes = [
    {
        path: 'structure',
        pageComponent: StructureBuilderPage,
    },
    {
        path: 'versions',
        pageComponent: VersionNew,
    },
    {
        path: 'versions/list',
        pageComponent: Versions,
    },
    {
        path: 'configuration',
        pageComponent: PlatformsPage,
    },
    {
        path: 'configuration/web',
        pageComponent: PlatformsWebPage,
    },
    {
        path: '/configuration/play-store',
        pageComponent: PlatformsPlayStorePage,
    },
    {
        path: '/configuration/app-store',
        pageComponent: PlatformsAppStorePage,
    },
    {
        path: 'distribution',
        pageComponent: PlatformsBuildsPage,
    },
    {
        path: 'publications',
        pageComponent: PublicationsPage,
    },
    {
        path: 'publications/new',
        pageComponent: PublicationsUpsertPage,
    },
    {
        path: 'publications/:platform/:publicationId/edit',
        pageComponent: PublicationsUpsertPage,
    },
    {
        path: 'copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "app" })); },
    },
    {
        path: 'permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "app", baseUrl: "/organizations/:organizationId/apps", crumbIter: 0 }))); },
    },
    {
        path: 'patchwork/:patchworkId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "patchwork", baseUrl: "/patchworks", crumbIter: 1, crumbSkip: 1 }))); },
    },
    {
        path: 'views',
        pageComponent: ViewsPage,
    },
    {
        path: 'views/new',
        pageComponent: ViewNew,
    },
    {
        path: 'views/:viewId',
        pageComponent: LegacyViewBuilder,
    },
    {
        path: 'views/:viewId/copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "view" })); },
    },
    {
        path: 'views/:viewId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "view", baseUrl: "/views", crumbIter: 2 }))); },
    },
    {
        path: 'logic/:logicId?',
        pageComponent: LogicBuilderPage,
    },
    {
        path: 'logic/:logicId/:reDirectPatchId',
        pageComponent: LogicBuilderPage,
    },
    {
        path: 'datasets',
        pageComponent: DatasetsList,
    },
    {
        path: 'datasets/new',
        pageComponent: DatasetNew,
    },
    {
        path: 'datasets/:datasetId',
        pageComponent: Dataset,
    },
    {
        path: 'datasets/:datasetId/settings',
        pageComponent: DatasetEdit,
    },
    {
        path: 'datasets/:datasetId/copy',
        pageComponent: ItemCopy,
    },
    {
        path: 'datasets/:datasetId/rules',
        pageComponent: DataSetPermissions,
    },
    {
        path: 'datasets/:datasetId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "dataset", baseUrl: "/datasets", crumbIter: 2 }))); },
    },
    {
        path: 'datasetitems/:datasetId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "dataset-items", baseUrl: "/datasets", crumbIter: 2 }))); },
    },
    {
        path: 'datasets/:datasetId/addrow',
        pageComponent: DatasetRow,
    },
    {
        path: 'datasets/:datasetId/edit/:rowId',
        pageComponent: DatasetRow,
    },
    {
        path: 'datasets/:datasetId/edit/:rowId/sendPush',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: 'integrations',
        pageComponent: IntegrationsPage,
    },
    {
        path: 'integrations/new',
        pageComponent: IntegrationNew,
    },
    {
        path: 'integrations/:integrationId',
        pageComponent: Integration,
    },
    {
        path: 'integrations/:integrationId/edit',
        pageRenderer: function (props) { return _jsx(IntegrationNew, __assign({}, props, { edit: true })); },
    },
    {
        path: 'integrations/:integrationId/method/new',
        pageComponent: IntegrationMethodCreatePage,
    },
    {
        path: 'integrations/:integrationId/method/:methodId',
        pageComponent: function (props) { return _jsx(IntegrationMethodCreatePage, __assign({}, props, { edit: true })); },
    },
    {
        path: 'media/:folderId/permissions',
        pageComponent: function (props) { return _jsx(TargetPermissions, __assign({}, props, { crumbIter: 0 })); },
    },
    {
        path: 'media/*',
        pageComponent: MediaExplorer,
    },
    {
        path: 'styles',
        pageComponent: StylesListPage,
    },
    {
        path: 'styles/new',
        pageComponent: StyleNew,
    },
    {
        path: 'styles/:styleId',
        pageComponent: StylesPage,
    },
    {
        path: 'styles/:styleId/copy',
        pageComponent: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "style" })); },
    },
    {
        path: 'styles/:styleId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "style", baseUrl: "/styles", crumbIter: 2 }))); },
    },
    {
        path: 'translations',
        pageComponent: Translations,
    },
    {
        path: 'translations/edit',
        pageComponent: Translation,
    },
    {
        path: 'translations/languages',
        pageComponent: Languages,
    },
    {
        path: 'state',
        pageComponent: State,
    },
    {
        path: 'storage',
        pageComponent: Storage,
    },
    {
        path: 'variables',
        pageComponent: Variable,
    },
    {
        path: 'environments',
        pageComponent: Environment,
    },
    {
        path: 'keys',
        pageComponent: AccessControlAPIKeys,
    },
    {
        path: 'access/targets',
        pageComponent: AccessControlPermissionItems,
    },
    {
        path: 'access/targets/:targetId',
        pageComponent: AccessControlTargetPermissions,
    },
    {
        path: 'roles',
        pageComponent: AccessControlRoles,
    },
    {
        path: 'roles/:roleId',
        pageComponent: AccessControlRolePermissions,
    },
    {
        path: 'permissions/:groupId',
        pageComponent: AppAdminPermissions,
    },
    {
        path: 'users',
        pageComponent: AppUsers,
    },
    {
        path: 'users/invite',
        pageComponent: UserInvite,
    },
    {
        path: 'users/:userId/edit',
        pageComponent: AppUserEdit,
    },
    {
        path: 'shareusers',
        pageComponent: UsersSharedApps,
    },
    {
        path: 'groups',
        pageComponent: Groups,
    },
    {
        path: 'admins/roles',
        pageComponent: Admins,
    },
    {
        path: 'admins',
        pageComponent: AppAdmins,
    },
    {
        path: 'admins/invite',
        pageComponent: InviteAppAdmin,
    },
    {
        path: 'groups/new',
        pageComponent: GroupNew,
    },
    {
        path: 'admins/new',
        pageComponent: AdminNew,
    },
    {
        path: 'groups/:groupId',
        pageComponent: GroupDetails,
    },
    {
        path: 'groups/:groupId/user/create',
        pageComponent: CreateAdminRole,
    },
    {
        path: 'admins/:groupId',
        pageComponent: AppAdminDetails,
    },
    {
        path: 'groups/:groupId/permissions',
        element: _jsx(Permissions, { type: "group", baseUrl: "/groups", crumbIter: 2 }),
    },
    {
        path: 'groups/:groupId/addmember',
        pageComponent: UserGroups,
    },
    {
        path: 'admins/:groupId/addmember',
        pageComponent: UserGroups,
    },
    {
        path: 'push',
        pageComponent: OldPushNotifications,
    },
    {
        path: 'push/new',
        pageComponent: OldPushNotifications,
    },
    {
        path: 'push/notifications',
        pageComponent: PushNotifications,
    },
    {
        path: 'push/notifications/:pushId',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: 'push/notifications/new',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: 'push/notifications/new/:groupId',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: 'permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "push", baseUrl: "/push/notifications", crumbIter: 2 }))); },
    },
    {
        path: 'push/templates',
        pageComponent: PushNotificationTemplates,
    },
    {
        path: 'push/templates/:templateId',
        pageComponent: PushNotificationTemplatesEdit,
    },
    {
        path: 'push/senderapps',
        pageComponent: PushNotificationsSenderApps,
    },
    {
        path: 'overview',
        pageComponent: AppOverview,
    },
    {
        path: 'settings/:open?',
        pageComponent: AppSettings,
    },
    {
        path: 'template',
        pageComponent: MakeTemplateBasicPage,
    },
    {
        path: 'template/selectPreview',
        pageComponent: SelectPreview,
    },
    {
        path: 'template/personalization',
        pageComponent: personalizationPage,
    },
    {
        path: '/template/publish',
        pageComponent: TemplatePublishPage,
    },
    {
        path: '/:appId',
        pageComponent: PatchSelectRedirectPage,
    },
];
